import * as React from 'react'
import { FC, PropsWithChildren } from 'react'
import { cls } from '../../utils/utils'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import LazyModal from './LazyModal/LazyModal'
import { IModal } from './Modal.types'
import styles from './Modal.module.scss'

const ModalComponent: FC<PropsWithChildren<IModal>> = (props) => {
  return (
    <>
      <LazyModal
        htmlOpenClassName={styles.resetNoScrollStyles}
        isOpen={props.modalIsOpen}
        onRequestClose={props.closeModal}
        contentLabel="Modal"
        className={props.className}
        overlayClassName={props.overlayClassName}
      >
        {props.hasMobileHeader && <Header className="desktop-hide" />}
        <a onClick={props.closeModal} className={cls('desktop-hide', styles.closeModal)}>
          <span className={styles.close} />
        </a>
        <div className={cls('main-container', styles.contentContainer, props.contentContainerClassName)}>
          <a onClick={props.closeModal} className={cls('mobile-hide', styles.closeModal)}>
            <span className={styles.close} />
          </a>
          {props.children}
        </div>
        {props.hasFooter && <Footer className={styles.footer} dottedRectanglesClassName={styles.dottedRectangles} />}
      </LazyModal>
    </>
  )
}

export default ModalComponent
